import { formatDate } from "@/core/helpers/DatetimeConverter";

const truncateMessage = (message?: string, maxLength = 120) => {
	if (!message) return '';
	const trimmed = message.trim();
	if (trimmed.length <= maxLength) return trimmed;
	return `${trimmed.slice(0, Math.max(0, maxLength - 3))}...`;
};

const ReportIssueMap = {
	Plural: 'Report Issue Requests',
	Single: 'Report Issue Request',
	ModalForm: false,
	DefaultSorting: 'id',
	DefaultSortingType: 'desc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			type: 'text',
		},
		{
			name: 'user',
			label: 'User',
			type: 'text',
			format: (item) => {
				const user = item.user || null;
				if (user != null) {
					return user.nickName ? `<div>${user.nickName}</div> <div>${user.email}</div> <div>${user.phone}</div>` : '';
				}

				return "";

			},
		},
		{
			name: 'message',
			dbName: 'message',
			label: 'Message',
			sortable: false,
			type: 'text',
			format: (row: any) => truncateMessage(row.message),
		},
		{
			name: 'createdAt',
			dbName: 'createdAt',
			label: 'CreatedAt',
			sortable: true,
			type: 'text',
			format: (row: any) => formatDate(row.createdAt),
		},
	],
	Filters: [],
	PrimaryKey: 'id',
	RowButtons: [
		{
			name: 'details',
			label: 'Details',
			type: 'button',
			iconOnly: true,
			fontIcon: 'bi bi-eye',
			modal: {
				title: 'Report An Issue Request',
				fields: [
					{ label: 'ID', key: 'id' },
					{ label: 'Date', key: 'createdAt' },
					{ label: 'User NickName', key: 'user.nickName' },
					{ label: 'User Email', key: 'user.email' },
					{ label: 'User Phone', key: 'user.phone' },
					{ label: 'Message', key: 'message' },
				],
			},
		},
	],
	Actions: {},
};

export default ReportIssueMap;
